import { processRequest } from "@api/config";
import { tokensInformationAPI } from "@api/tokensInformation";

import { useAuthQuery } from "@lib/queryClient";

import { API_PREFIXES, QUERY_KEYS } from "@configs/api";

export const useTokensPast12hQuery = () =>
	useAuthQuery({
		queryKey: [QUERY_KEYS.TOKEN_PAST_12H],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_TOKEN_PAST_12H,
				request: (token) => tokensInformationAPI.getTokensPast12hAsync({ token }),
			});

			return data.amount;
		},
	});
